/**
 * @generated SignedSource<<94582bc321b1cc21e47c5ee4d2e8bb0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminDevicesScreenQuery$variables = Record<PropertyKey, never>;
export type OrgAdminDevicesScreenQuery$data = {
  readonly organisation: {
    readonly id: string;
    readonly sharedMobileDevices: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly lastIPConformsToCIDR: boolean | null;
          readonly lastUsedAtDate: {
            readonly isoString: string;
          } | null;
          readonly name: string;
          readonly store: {
            readonly externalId: string | null;
            readonly id: string;
            readonly name: string;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"OrgMobileDeviceListItem_device">;
        };
      }>;
    } | null;
    readonly storecastScreens: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly lastIPConformsToCIDR: boolean | null;
          readonly lastUsedAtDate: {
            readonly isoString: string;
          } | null;
          readonly name: string;
          readonly store: {
            readonly externalId: string | null;
            readonly id: string;
            readonly name: string;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"OrgScreenListItem_screen">;
        };
      }>;
    } | null;
  };
};
export type OrgAdminDevicesScreenQuery = {
  response: OrgAdminDevicesScreenQuery$data;
  variables: OrgAdminDevicesScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastIPConformsToCIDR",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "lastUsedAtDate",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "lastUsedAtDate",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "style",
          "value": "DATE_ONLY"
        }
      ],
      "kind": "ScalarField",
      "name": "storeFormattedDate",
      "storageKey": "storeFormattedDate(style:\"DATE_ONLY\")"
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeExternalId",
          "value": false
        }
      ],
      "kind": "ScalarField",
      "name": "workspaceBreadcrumbs",
      "storageKey": "workspaceBreadcrumbs(includeExternalId:false)"
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastIP",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminDevicesScreenQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": (v1/*: any*/),
              "concreteType": "StorecastScreenConnection",
              "kind": "LinkedField",
              "name": "storecastScreens",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StorecastScreenEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StorecastScreen",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v5/*: any*/),
                        (v7/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "OrgScreenListItem_screen"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "storecastScreens(first:1000)"
            },
            {
              "alias": null,
              "args": (v1/*: any*/),
              "concreteType": "SharedMobileDeviceConnection",
              "kind": "LinkedField",
              "name": "sharedMobileDevices",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SharedMobileDeviceEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SharedMobileDevice",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v5/*: any*/),
                        (v7/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "OrgMobileDeviceListItem_device"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "sharedMobileDevices(first:1000)"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgAdminDevicesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StorecastScreenConnection",
            "kind": "LinkedField",
            "name": "storecastScreens",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StorecastScreenEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StorecastScreen",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "storecastScreens(first:1000)"
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SharedMobileDeviceConnection",
            "kind": "LinkedField",
            "name": "sharedMobileDevices",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SharedMobileDeviceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SharedMobileDevice",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": true,
                        "selections": [
                          (v0/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "sharedMobileDevices(first:1000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "373d69318e15fbe0f65441b2eaeeba17",
    "id": null,
    "metadata": {},
    "name": "OrgAdminDevicesScreenQuery",
    "operationKind": "query",
    "text": "query OrgAdminDevicesScreenQuery {\n  organisation {\n    id\n    storecastScreens(first: 1000) {\n      edges {\n        node {\n          id\n          name\n          lastIPConformsToCIDR\n          lastUsedAtDate {\n            isoString\n          }\n          store {\n            id\n            name\n            externalId\n          }\n          ...OrgScreenListItem_screen\n        }\n      }\n    }\n    sharedMobileDevices(first: 1000) {\n      edges {\n        node {\n          id\n          name\n          lastIPConformsToCIDR\n          lastUsedAtDate {\n            isoString\n          }\n          store {\n            id\n            name\n            externalId\n          }\n          ...OrgMobileDeviceListItem_device\n        }\n      }\n    }\n  }\n}\n\nfragment OrgMobileDeviceListItem_device on SharedMobileDevice {\n  name\n  lastUsedAtDate {\n    storeFormattedDate(style: DATE_ONLY)\n  }\n  lastIP\n  lastIPConformsToCIDR\n  teams {\n    id\n    name\n  }\n  store {\n    name\n    ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store\n    id\n  }\n}\n\nfragment OrgScreenListItem_screen on StorecastScreen {\n  name\n  status\n  lastUsedAtDate {\n    storeFormattedDate(style: DATE_ONLY)\n  }\n  lastIP\n  lastIPConformsToCIDR\n  store {\n    name\n    ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store\n    id\n  }\n}\n\nfragment OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store on Store {\n  workspaceBreadcrumbs(includeExternalId: false)\n}\n"
  }
};
})();

(node as any).hash = "7948fb27a026fc2417d798947b900971";

export default node;
